import { useQuery } from '@tanstack/react-query';
import { serviceService } from '../services/serviceService';
import type { Service } from '../types/service.types';

const EMPTY: Service[] = [];

/**
 * Phase 6: was a hand-rolled useState/useEffect fetch with no retry, no cache
 * and no dedupe. The exported shape `{ data, isLoading, error }` is unchanged,
 * so no consuming page needed touching — the client Dashboard alone reads four
 * of these hooks.
 *
 * `data` is never undefined: callers do `services.filter(...)` directly, so a
 * stable empty array is returned until the first result lands.
 */
export function useServices() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['hosting', 'services'],
    queryFn: () => serviceService.list(),
  });

  return {
    data: data ?? EMPTY,
    isLoading,
    error: (error as Error | null) ?? null,
    refetch,
  };
}
